import React from "react";
import styled from "styled-components";
import { ContactForm } from "./ContactForm";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialsCarousel from "./TestimonialsCarousel";
import DiscordButton from "./DiscordButton";
import imageIGicon from "./images/ig-icon-small.png";
import imageFBicon from "./images/fb-icon-small.png";

// Carousel images
import imageAndroidLegacy from "./images/android_legacy.jpg";
import imageJenny from "./images/jenny.jpg";
import imageWatercolorAndroids from "./images/android-colored-small.jpg";
import imageFemaleAndroid from "./images/female-anthroid-floating-trans-small.png";
import imageAndroidLegacy3 from "./images/android_legacy_iii.jpg";

import { FlexContainer, Caption, Header, Paragraph } from "./styles";

const Image = styled.img``;

const ImageCarouselContainer = styled.div`
  max-width: 458px;
  width: 100%;
  text-align: right;
  margin-bottom: 40px;

  .slick-dots li button:before {
    font-size: 12px;
    color: gray;
  }

  .slick-dots li.slick-active button:before {
    color: gray;
  }
`;

const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const CarouselImage = styled.img`
  width: 100%;
  max-width: 458px;
  max-height: 623px;
  height: auto;
  display: block;
`;

const ImageCaption = styled.span`
  margin: 15px 0px;
  font-family: "Josefin Sans", sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  text-align: right;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: right;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0px 35px 0px 35px;
`;

const FollowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const BoldSpan = styled.span`
  font-weight: 600;
`;

const Break = styled.div`
  width: 100%;
  height: 1.5em;
`;

const StyledLink = styled(Link)`
  color: inherit;
`;

const images = [
  {
    src: imageAndroidLegacy,
    alt: "Android Legacy: The Grid by Oliver Wetter",
    caption: "art by oliver wetter",
  },
  {
    src: imageJenny,
    alt: "Jenny by Lesha Porche",
    caption: "art by lesha porche",
  },
  {
    src: imageWatercolorAndroids,
    alt: "Watercolor Androids by João Fraga",
    caption: "art by João Fraga",
  },
  {
    src: imageFemaleAndroid,
    alt: "Female Android by Yash Tanwani",
    caption: "art by Yash Tanwani",
  },
  {
    src: imageAndroidLegacy3,
    alt: "Android Legacy 3 by Oliver Wetter",
    caption: "art by Oliver Wetter",
  },
];

export default function Home() {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <div>
      <TestimonialsCarousel />
      <FlexContainer>
        <LeftColumn>
          <ImageCarouselContainer>
            <Slider {...carouselSettings}>
              {images.map((image, index) => (
                <SlideContainer key={index}>
                  <CarouselImage src={image.src} alt={image.alt} />
                  <ImageCaption>{image.caption}</ImageCaption>
                </SlideContainer>
              ))}
            </Slider>
          </ImageCarouselContainer>
        </LeftColumn>

        <RightColumn>
          <Paragraph>
            It's the year 2071, and artificially-intelligent androids are
            ubiquitous in society: they cook and clean, construct and destruct;
            they do our dirty work, even fight on battlefields for us. But
            though they may look and act like humans, they're not conscious, and
            they can never become conscious—
            <BoldSpan>
              at least, that's what their manufacturers would have you believe.
            </BoldSpan>
            <Break></Break>
            <BoldSpan>You play a newly-awakened Sentient,</BoldSpan> a
            self-aware constructed entity, fighting for survival and freedom in
            a world that doesn’t even acknowledge your existence.
            <Break></Break>
            <BoldSpan>
              S E N T I E N T S is a tabletop roleplaying game of liberation,
              underground resistance, newfound emotion, and what it means to be
              something other than human.
            </BoldSpan>
            <Break></Break>
            Now available for purchase: the{" "}
            <StyledLink to="/buy">Sentients Core Rulebook</StyledLink>!
          </Paragraph>
          <br />
          <br />
          <Paragraph>
            <Header>FOLLOW &amp; DISCUSS</Header>

            <FollowContainer>
              <a
                href="https://www.instagram.com/sentientsrpg?utm_source=sentientsrpg&utm_medium=website&utm_campaign=social_follow"
                target="_blank"
                rel="noopener"
              >
                <Image src={imageIGicon} alt="Follow on Instagram" />
              </a>
              &nbsp;&nbsp;
              <a
                href="https://www.facebook.com/profile.php?id=61557928403465?utm_source=sentientsrpg&utm_medium=website&utm_campaign=social_follow"
                target="_blank"
                rel="noopener"
              >
                <Image src={imageFBicon} alt="Follow on Facebook" />
              </a>
              &nbsp;&nbsp;
              <DiscordButton
                isSSO={false}
                url={"https://discord.gg/p4m6DQUjjY"}
              />
            </FollowContainer>
          </Paragraph>
          <br />
          <br />
          <Paragraph>
            <Header>SIGN UP FOR NEWS</Header>
            <ContactForm />
          </Paragraph>

          <Caption>GAME DESIGN BY TED HAYES</Caption>
        </RightColumn>
      </FlexContainer>
    </div>
  );
}
